import React from 'react';
import classnames from 'classnames';
import { FaFacebookF, FaLinkedinIn, FaGlobeAsia } from 'react-icons/fa';
import { AiOutlineInstagram, AiOutlineTwitter } from 'react-icons/ai';

import { identity, isTechnicalLicense } from 'utils';
import { ImageIcon } from 'assets/icons';
import { ProfileOverviewProps } from 'types/componentTypes/ProfileOverviewProps';
import { RenderIf } from 'components/components';

import './ProfileOverview.scss';

const ProfileOverview = (props: ProfileOverviewProps) => {
  const {
    imageUrl,
    heading,
    coverImage,
    rightContent,
    mainSubheading,
    socialMediaLinks,
    userType,
    type,
  } = props;
  const isRealImageLink = imageUrl?.includes('/media')!;

  return (
    <div className="profile-overview">
      <div className="profile-overview__left-content-container">
        <RenderIf condition={!isTechnicalLicense(userType)}>
          <div className="profile-overview__image-container">
            {identity.isTruthyString(imageUrl) && isRealImageLink
              ? <img className={classnames('profile-overview__image', { 'cover-image': coverImage })} src={imageUrl} alt={heading} />
              : (
                <div className="profile-overview__no-image-container">
                  <ImageIcon />
                </div>
              )}
          </div>
        </RenderIf>

        <div className="profile-overview__left-content-item">
          <h3 className="profile-overview__heading">{heading}</h3>
          <RenderIf condition={identity.isTruthyString(mainSubheading)}>
            <div className="profile-overview__subheading-container">
              <span className="profile-overview__subheading">
                {mainSubheading}
              </span>
            </div>
          </RenderIf>
          <RenderIf condition={!isTechnicalLicense(userType)}>
            <RenderIf condition={identity.isObjWithChildren(socialMediaLinks)}>
              <div className="profile-overview__right-content-item">
                <div className="profile-overview__social-media">
                  {identity.isTruthyString(socialMediaLinks?.facebook) && (
                    <div className="profile-overview__social-media-item">
                      <a aria-label="facebook" rel="noopener noreferrer" target="_blank" href={socialMediaLinks?.facebook!}>
                        <FaFacebookF color="000" />
                      </a>
                    </div>
                  )}

                  {identity.isTruthyString(socialMediaLinks?.instagram) && (
                    <div className="profile-overview__social-media-item">
                      <a aria-label="instagram" rel="noopener noreferrer" target="_blank" href={socialMediaLinks?.instagram!}>
                        <AiOutlineInstagram color="000" />
                      </a>
                    </div>
                  )}

                  {identity.isTruthyString(socialMediaLinks?.twitter) && (
                    <div className="profile-overview__social-media-item">
                      <a aria-label="twitter" rel="noopener noreferrer" target="_blank" href={socialMediaLinks?.twitter!}>
                        <AiOutlineTwitter color="000" />
                      </a>
                    </div>
                  )}

                  {identity.isTruthyString(socialMediaLinks?.linkedIn) && (
                    <div className="profile-overview__social-media-item">
                      <a aria-label="linkedin" rel="noopener noreferrer" target="_blank" href={socialMediaLinks?.linkedIn!}>
                        <FaLinkedinIn color="000" />
                      </a>
                    </div>
                  )}

                  {identity.isTruthyString(socialMediaLinks?.website) && (
                    <div className="profile-overview__social-media-item">
                      <a aria-label="website" rel="noopener noreferrer" target="_blank" href={socialMediaLinks?.website!}>
                        <FaGlobeAsia color="000" />
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </RenderIf>
          </RenderIf>
        </div>
      </div>
      <div className="profile-overview__right-content">
        <div className={`profile-overview__right-content-${type === 'grid' ? 'container-grid' : 'container'}`}>
          {rightContent.map(({ label, value }) => (
            <div className="profile-overview__right-content-item" key={label}>
              <span className="profile-overview__right-content-item--label">{label}</span>
              <span className="profile-overview__right-content-item--value">{identity.isTruthyString(value?.toString()) ? value : 'Not specified'}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

ProfileOverview.defaultProps = {
  coverImage: false,
  subheadingIsLocation: false,
  socialMediaLinks: {},
}

export default ProfileOverview;
